const getDaysUntilMatch = ({ matchDate }: { matchDate: Date }) => {
  return Math.abs(Math.round((matchDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
}

export default getDaysUntilMatch
